<div class="wrap" [class.is-carousel]="carousel()">
  @if (carousel()) {
    <button class="hs-nav prev" type="button" [attr.aria-label]="'HOME.NAV.PREV' | translate" [disabled]="!canPrev()" (click)="scroll(-1)">
      <i class="ls-chevron-left"></i>
    </button>
    <button class="hs-nav next" type="button" [attr.aria-label]="'HOME.NAV.NEXT' | translate" [disabled]="!canNext()" (click)="scroll(1)">
      <i class="ls-chevron-right"></i>
    </button>
  }
  <div class="recueils-grid" #track>
    @for (r of recueils(); track r.code) {
      <a class="recueil-card" [routerLink]="publicRoute(basePath(), r.slug)"
        [class.has-cover]="!!r.imagePath"
        [style.background-image]="r.imagePath ? 'url(/assets/' + r.imagePath + ')' : null"
        [attr.data-testid]="'recueil-card-' + r.slug">
        @if(showSigle()){
          <div class="sig" [style.--sig-color]="sigColor(r.color)">{{ r.sig }}</div>
        }
        <div class="ti">{{ r.name }}</div>
        <div class="meta">{{ r.lyricsCount }}</div>
        <!-- Ne pas supprimer cette partie elle sera utiliser dans cette section plutard
        <div style="display: none;" class="progress"><div [style.width.%]="r.progress"></div></div>
        <div style="display: none;" class="progress-l">
          <span>{{ r.read }}</span>
          <span>{{ r.progress }} %</span>
        </div> -->
      </a>
    }
  </div>
</div>
